// extracted by mini-css-extract-plugin
export default {"quality":"Quality_quality__c5HFo","quality-icon":"Quality_quality-icon__BkKcu"};